import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/adduser.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm adduser

aliases: login, add-user
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/adduser.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Create or verify a user named `}<inlineCode parentName="p">{`<username>`}</inlineCode>{` in the specified registry, and
save the credentials to the `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file. If no registry is specified,
the default registry will be used (see `}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/config"
      }}><inlineCode parentName="a">{`config`}</inlineCode></a>{`).`}</p>
    <p>{`The username, password, and email are read in from prompts.`}</p>
    <p>{`To reset your password, go to `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/forgot"
      }}>{`https://www.npmjs.com/forgot`}</a></p>
    <p>{`To change your email address, go to `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/email-edit"
      }}>{`https://www.npmjs.com/email-edit`}</a></p>
    <p>{`You may use this command multiple times with the same user account to
authorize on a new machine.  When authenticating on a new machine,
the username, password and email address must all match with
your existing record.`}</p>
    <p><inlineCode parentName="p">{`npm login`}</inlineCode>{` is an alias to `}<inlineCode parentName="p">{`adduser`}</inlineCode>{` and behaves exactly the same way.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`scope`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: the scope of the current project, if any, or ""`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`Associate an operation with a scope for a scoped registry.`}</p>
    <p>{`Useful when logging in to or out of a private registry:`}</p>
    <pre><code parentName="pre" {...{}}>{`# log in, linking the scope to the custom registry
npm login --scope=@mycorp --registry=https://registry.mycorp.com

# log out, removing the link and the auth token
npm logout --scope=@mycorp
`}</code></pre>
    <p>{`This will cause `}<inlineCode parentName="p">{`@mycorp`}</inlineCode>{` to be mapped to the registry for future
installation of packages specified according to the pattern
`}<inlineCode parentName="p">{`@mycorp/package`}</inlineCode>{`.`}</p>
    <p>{`This will also cause `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` to create a scoped package.`}</p>
    <pre><code parentName="pre" {...{}}>{`# accept all defaults, and create a package named "@foo/whatever",
# instead of just named "whatever"
npm init --scope=@foo --yes
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`auth-type`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "legacy"`}</li>
      <li parentName="ul">{`Type: "legacy", "web", "sso", "saml", "oauth", or "webauthn"`}</li>
    </ul>
    <p>{`NOTE: auth-type values "sso", "saml", "oauth", and "webauthn" will be
removed in a future version.`}</p>
    <p>{`What authentication strategy to use with `}<inlineCode parentName="p">{`login`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-owner"
        }}>{`npm owner`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-whoami"
        }}>{`npm whoami`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-token"
        }}>{`npm token`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-profile"
        }}>{`npm profile`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      